import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import {
  TRIP_STORE_PERSIST_NAME,
  partializeTripState,
  createTripStorage,
} from './tripStorePersist';
import { TripSlice, createTripSlice } from './tripSlice';
import { FiltersSlice, createFiltersSlice } from './filtersSlice';
import { UiSlice, createUiSlice } from './uiSlice';

// The store is split into slices by concern (US-046): tripSlice (days,
// experiences, hotels), filtersSlice (tripFilters, libraryFilters) and
// uiSlice (everything else `TripDesignerProvider` holds as plain React
// state today). Only tripSlice and filtersSlice are persisted — see
// `partializeTripState`, which never reads a uiSlice field.
type TripStoreState = TripSlice & FiltersSlice & UiSlice;

const useTripStore = create<TripStoreState>()(
  devtools(
    persist(
      (set, get) => ({
        ...createTripSlice(set, get),
        ...createFiltersSlice(set),
        ...createUiSlice(set),
      }),
      {
        name: TRIP_STORE_PERSIST_NAME,
        version: 1,
        storage: createJSONStorage(createTripStorage),
        partialize: partializeTripState,
      },
    ),
    { name: 'TripDesignerStore' },
  ),
);

export default useTripStore;
